"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEGMENT = exports.ICON_POSITION = exports.BUTTON_TARGET = exports.BUTTON_OPERATION = exports.BUTTON_FONT_FAMILY = exports.BUTTON_BORDER_RADIUS = exports.BUTTON_TYPE_HTML = exports.BUTTON_TYPE = exports.BUTTON_WIDTH = exports.BUTTON_HEIGHT = void 0;
exports.BUTTON_HEIGHT = {
    NORMAL: 'normal',
    SMALL: 'small',
};
exports.BUTTON_WIDTH = {
    DEFAULT: 'default',
    FULL: 'full',
};
exports.BUTTON_TYPE = {
    PRIMARY: 'primary',
    PRIMARY_REVERSE: 'primary_reverse',
    SECONDARY: 'secondary',
    SECONDARY_REVERSE: 'secondary_reverse',
    DANGER: 'danger',
    HEADER: 'header',
    HEADER_REVERSE: 'header_reverse',
    HEADER_PRIORITY: 'header_priority',
    HEADER_PRIORITY_REVERSE: 'header_priority_reverse',
    SELECTED: 'selected',
    SELECTED_REVERSE: 'selected_reverse',
    TAB: 'tab',
    TAB_ACTIVE: 'tab_active',
};
exports.BUTTON_TYPE_HTML = {
    BUTTON: 'button',
    SUBMIT: 'submit',
};
exports.BUTTON_BORDER_RADIUS = {
    NONE: 'none',
    SMALL: 'small',
    MEDIUM: 'medium',
    FULL: 'full',
    BIG: 'big',
    BIG_SHADOW: 'bigWithShadow',
};
exports.BUTTON_FONT_FAMILY = {
    REGULAR: 'regular',
    BOLD: 'bold',
    LIGHT: 'light',
};
exports.BUTTON_OPERATION = {
    LOADING: 'loading',
    SUCCESS: 'success',
    FAILURE: 'failure',
    NO: 'no',
};
exports.BUTTON_TARGET = {
    SELF: '_self',
    NEWTAB: '_blank',
    PARENT: 'parent',
    TOP: '_top',
};
exports.ICON_POSITION = {
    LEFT: 'left',
    RIGHT: 'right',
};
exports.SEGMENT = {
    PARTICULARES: 'particulares',
    EMPRESAS: 'empresas',
    GP: 'gp',
    EMP: 'emp',
};
//# sourceMappingURL=enums.js.map